import { FC, useEffect, useRef, useState } from "react";
import { AITabs } from "aio-input";
import { I_freelancer, I_hub, I_imageKey } from "../types";
import EttelaateFardi from "./ettelaateFardi";
import EttelaateKhodro from "./ettelaateKhodro";
import FreelancerNumbers from "./numbers";
import TasvireMadarek from "./tasvireMadarek";
import AIODate from "aio-date";
import Footer from "./footer";
import { useFreelancer } from "../context";
type I_tab = 0 | 1 | 2
const Freelancer: FC<{ id?: number }> = ({ id }) => {
    const { apis, gridHook, popup, imageDic, options } = useFreelancer()
    const imageUploadedDic = useRef<{ [key in I_imageKey]?: string | undefined }>({})
    const [tab, setTab] = useState<I_tab>(0)
    const [type, setType] = useState<'add' | 'edit'>(id === undefined ? 'add' : 'edit')
    const [ettelaateFardiDisabled, setEttelaateFardiDisabled] = useState<boolean>(true)
    const [freelancerNumbersDisabled, setFreelancerNumbersDisabled] = useState<boolean>(true)
    const [ettelaateKhodroDisabled, setEttelaateKhodroDisabled] = useState<boolean>(true)
    const [data, setData] = useState<I_freelancer>()
    const dataRef = useRef<any>(data)
    dataRef.current = data
    const getData = async () => {
        if (id === undefined) {
            setData({
                ettelaateFardi: {
                    phone: '',
                    birthDate: '',
                    essentialPhone: '',
                    fatherName: '',
                    gender: 1,
                    isActive: true,
                    address: ''
                },
                numbers: {
                    shomareGavahiname: '',
                    shomareSafte: '',
                    shomareGharardad: '',
                    shomareSheba: ''
                },
                ettelaateKhodro: {},
                tasvireMadarek: {}
            })
        }
        else {
            const res = await apis.initialEdit(id);
            if (res) { setData(res.freelancer) }
        }
    }
    useEffect(() => {
        getData()
    }, [])
    const isDisabled = () => {
        if (tab === 0) { return !!ettelaateFardiDisabled || !!freelancerNumbersDisabled }
        if (tab === 1) { return !!ettelaateKhodroDisabled }
        return false
    }
    const submit = async () => {
        const data = dataRef.current
        if (!data) { return }
        const {
            nationalCode, name, mobile, email, isActive, fatherName, birthDate, gender, phone, essentialPhone, shahr, address, hub
        } = data.ettelaateFardi
        const hubObject = options.hubs.find((o: any) => o.id === hub) as any
        const obj: any = {
            nationalCode, name, mobile, email, isActive, fatherName, phone, essentialPhone,//
            birthDate: toIsoDate(birthDate || '1403/4/5'),//notice iso date???//
            gender: { id: gender },
            residentCity: { id: shahr },
            residentAddress: address,
            type: { id: 0 },
            username: mobile,
            hubId: hub,
            hubCodes: [hubObject.code]
        }

        obj.drivingLicenceNo = data.numbers.shomareGavahiname;
        obj.contractNo = data.numbers.shomareGharardad;
        obj.bankPaperNo = data.numbers.shomareSafte
        obj.iban = data.numbers.shomareSheba;
        if (type === 'add') {
            const res = await apis.add(obj)
            if (res) {
                gridHook.updateGrid()
                setTab(1);
                setType('edit');
                setData(res.freelancer)
                popup.addSnackebar({
                    type: 'success', text: `افزودن با موفقیت انجام شد`,
                    align: ['right', 'top']
                })
            }
        }

        if (type === 'edit') {
            const id = data.id as number;
            if (data.ettelaateKhodro.tarikheEtebareBimeName) { obj.vehicleInsuranceExpire = convertDate(data.ettelaateKhodro.tarikheEtebareBimeName) }
            obj.vehicleType = typeof data.ettelaateKhodro.noeVasileNaghlie === 'number' ? { id: data.ettelaateKhodro.noeVasileNaghlie } : null
            obj.vehicleVin = data.ettelaateKhodro.vin;
            if (data.ettelaateKhodro.modeleVasileNaghlie) {
                obj.vehicleMake = { id: data.ettelaateKhodro.modeleVasileNaghlie }
            }
            const pelak = data.ettelaateKhodro.pelak || []
            obj.vehicleNumberPart0 = pelak[0]
            obj.vehicleNumberPart1 = pelak[1]
            obj.vehicleNumberPart2 = pelak[2]
            obj.vehicleNumberPart3 = pelak[3]
            if (data.tasvireMadarek) {
                for (let prop in imageDic) {
                    let { imageId, url,newUpload } = data.tasvireMadarek[imageDic[prop]] || {}
                    if (url) {
                        if (newUpload) {
                            if(url.indexOf('http') === 0){
                                //danger
                                debugger
                            }
                            const res = await apis.upload(url);
                            if (res) { imageId = res }
                        }
                        obj[prop] = imageId
                    }
                }
            }
            const res = await apis.edit(obj, id)
            if (res) {
                //اگر اطلاعات خودرو رو زد برو تب مدارک
                if (tab === 1) { setTab(2) }
                //اگر مدارک رو زد ببند مدال رو
                if (tab === 2) { popup.removeModal(); }
                gridHook.updateGrid()
                popup.addSnackebar({
                    type: 'success', text: `ویرایش با موفقیت انجام شد`,
                    align: ['right', 'top']
                })
            }
        }
    }
    const currentData = dataRef.current
    if (!currentData) { return null }
    return (
        <div className="flex-col- gap-16-">
            <AITabs
                style={{ height: 36 }}
                options={[
                    { text: 'اطلاعات فردی', value: 0 },
                    { text: 'اطلاعات خودرو', value: 1, disabled: type === 'add' },
                    { text: 'تصویر مدارک', value: 2, disabled: type === 'add' }
                ]}
                value={tab}
                className='brd-c-14- brd-b-'
                option={{ justify: () => true, style: () => ({ flex: 1 }) }}
                onChange={(tab) => setTab(tab)}
            />
            {
                tab === 0 &&
                <EttelaateFardi
                    data={currentData.ettelaateFardi}
                    onChange={(ettelaateFardi) => {
                        const data = dataRef.current
                        setData({ ...data, ettelaateFardi })
                    }}
                    setDisabled={(v) => {
                        if (ettelaateFardiDisabled !== v) { setEttelaateFardiDisabled(v) }
                    }}
                />
            }
            {
                tab === 0 &&
                <FreelancerNumbers
                    data={currentData.numbers}
                    onChange={(numbers) => {
                        const data = dataRef.current
                        setData({ ...data, numbers })
                    }}
                    setDisabled={(v) => {
                        if (freelancerNumbersDisabled !== v) { setFreelancerNumbersDisabled(v) }
                    }}
                />
            }
            {
                tab === 1 &&
                <EttelaateKhodro
                    data={currentData.ettelaateKhodro}
                    onChange={(ettelaateKhodro) => {
                        const data = dataRef.current;
                        const newData = { ...data, ettelaateKhodro }
                        setData(newData)
                    }}
                    setDisabled={(v) => {
                        if (ettelaateKhodroDisabled !== v) { setEttelaateKhodroDisabled(v) }
                    }}
                />
            }
            {
                tab === 2 &&
                <TasvireMadarek
                    data={currentData.tasvireMadarek}
                    onChange={(tasvireMadarek) => {
                        const data = dataRef.current;
                        setData({ ...data, tasvireMadarek })
                    }}
                />
            }
            {

            }
            <Footer onSubmit={submit} onClose={() => popup.removeModal()} isDisabled={isDisabled} />
        </div>
    )
}
export default Freelancer
const convertDate = (dateString: string): { year: number, month: number, day: number } => {
    const [year, month, day] = new AIODate().convertToArray(dateString)
    return { year, month, day }
}
const toIsoDate = (birthDate: string) => {
    const DATE = new AIODate();
    const dd = DATE.toGregorian(birthDate)
    const [y, m, d] = DATE.convertToArray(dd)
    return new Date(y, m - 1, d).toISOString();
}